import { ExtensionStyle } from "@/types/dto/pdp/pdp-itinerary";
import { ColletteIconButton } from "@collette-travel/collette-common-controls";
import { Close } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import { useTranslations } from "next-intl";

interface ExtensionStylesModalProps {
  handleClose: () => void;
  extensionStyleProps: ExtensionStyle[];
  currentExtensionStyle: string;
}

const ExtensionStylesModal = ({
  handleClose,
  extensionStyleProps,
  currentExtensionStyle
}: ExtensionStylesModalProps) => {
  const t = useTranslations("PDP");
  const selectedExtension = extensionStyleProps.find(
    (extension) => extension.name.toLowerCase() === currentExtensionStyle.toLowerCase()
  );
  return (
    <Stack
      sx={{
        p: { xs: "2.4rem", sm: "4rem", md: "4rem 6rem" },
        maxWidth: "82rem",
        maxHeight: "80vh",
        gap: "2.4rem",
        position: "relative"
      }}
      data-testid="extension-styles-modal-root"
    >
      <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
        {selectedExtension?.imageUrl && selectedExtension?.imageAltTag && (
          <Image
            src={selectedExtension?.imageUrl}
            alt={selectedExtension?.imageAltTag}
            width={60}
            height={60}
            style={{
              objectFit: "contain",
              maxWidth: "100%",
              maxHeight: "100%"
            }}
          />
        )}
        <Typography
          id="modal-modal-title"
          variant="h5"
          textAlign="left"
          data-testid="extension-styles-modal-title"
        >
          Extension Style: {selectedExtension?.name}
        </Typography>
      </Box>
      <Typography
        data-testid="extension-styles-modal-description"
        dangerouslySetInnerHTML={{
          __html:
            selectedExtension?.description ||
            t("Extension Style Unavailable")
        }}
      />
      <ColletteIconButton
        testId="extension-styles-modal-close-button"
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: "1.6rem",
          right: "1.6rem"
        }}
      >
        <Close />
      </ColletteIconButton>
    </Stack>
  );
};

export default ExtensionStylesModal;
